import './Settings.scss';

import { NavLink, Outlet } from 'react-router-dom';
import { Icon } from '@iconify/react';
import TopNav from '../../components/TopNav/TopNav';
import SideBar from '../../components/SideBar/SideBar';

const tabs = [
    { to: 'privacy', icon: 'solar:lock-keyhole-outline', label: 'Update Password' },
    { to: 'notifications', icon: 'solar:bell-outline', label: 'Notifications' },
    { to: 'terms-and-conditions', icon: 'solar:document-text-outline', label: 'Terms & Conditions' },
    { to: 'privacy-policy', icon: 'solar:shield-check-outline', label: 'Privacy Policy' },
    { to: 'sms-access', icon: 'solar:smartphone-2-outline', label: 'Text Access Code' },
];

function Settings() {
    return (
        <main>
            <TopNav />
            <div className='main-container'>
                <SideBar />
                <article className="page-content">
                    <section className='settings'>
                        <h1>Settings</h1>
                        <div className='settings__layout'>
                            <nav className='settings__nav'>
                                {tabs.map(tab => (
                                    <NavLink
                                        key={tab.to}
                                        to={tab.to}
                                        className={({ isActive }) =>
                                            `settings__nav-item ${isActive ? 'is-active' : ''}`
                                        }
                                    >
                                        <Icon icon={tab.icon} className='settings__nav-icon' />
                                        <span>{tab.label}</span>
                                    </NavLink>
                                ))}
                            </nav>
                            <div className='settings__card'>
                                <Outlet />
                            </div>
                        </div>
                    </section>
                </article>
            </div>
        </main>
    );
}

export default Settings;
